

































































































import VueOptions from '@utils/VueOptions'
import UiList from '@superUI/List/List'
import RequestButton from '@/components/RequestButton'
import Trigger from '@modules/ui/triggers/Trigger'
import ResourceList from '@modules/ui/List/ResourceList'
import OfferResourceListFilters from '@superUI/ResourceList/OfferResourceListFilters'
import LoadingIndicator from '@/components/LoadingIndicator'

settings =
  name: 'OfferResourceList'
  components: {
    UiList,
    RequestButton,
    Trigger,
    ResourceList,
    OfferResourceListFilters,
    LoadingIndicator
  }

  vue:
    props: ['offers', 'actions', 'filtersOverriden', 'infiniteWrapper', 'options']

    data: ->
      pageNumber: 1

      sortList: [
        { field: 'ctx.sponsor.org.name', value: 'Brand' }
        { field: 'ctx.supplier.org.name', value: 'University' }
        { field: 'expires_at', value: 'Expires At' }
        { field: 'ctx.event.local_start_day', value: 'Event Date' }
        { field: 'horizon', value: 'Horizon' }
        { field: 'created_at', value: 'Created At' }
        { field: 'updated_at', value: 'Updated At' }
        { field: 'draft_at', value: 'Draft At' }
        { field: 'submitted_at', value: 'Submitted At' }
        { field: 'accepted_at', value: 'Accepted At' }
        { field: 'denied_at', value: 'Denied At' }
        { field: 'in_revision_at', value: 'In Revision At' }
        { field: 'ignored_at', value: 'Ignored At' }
        { field: 'canceled_at', value: 'Canceled At' }
      ]
      sortValue: ''

      filters:
        scopes:
          workflow: 'pending'
          state: null
          horizon: null

        filters:
          accepted_after: ''
          accepted_before: ''
          denied_after: ''
          denied_before: ''
          submitted_after: ''
          submitted_before: ''

        q: ''
        sort: [] # { field: 'expires_at', order: 'desc' }

      selectedOffers: []
      selectedFilters: [{ key: 'workflow', name: 'Pending', value: 'pending' }]

      deleteModal:
        modalOptions:
          title: 'Delete Offer'
          button:
            label: 'Delete'
            type: 'danger'

    mounted: ->
      @filters = @filtersOverriden if @filtersOverriden?

    computed:
      components: ->
        {
          'offer-resource-list-item': () => import('./OfferResourceListItem')
        }
      title: ->
        @options?.title || 'Offers'

      resourceKey: ->
        @options?.resourceKey || 'offers'

      deleteTriggerResource: ->
        { key: @resourceKey, triggerName: 'delete', component: @$parent.$parent }

      deleteTriggerPayload: ->
        payload =
          offer_ids: @selectedOffers.map((e) -> e.id)
        payload

      availableSort: ->
        ctx = this
        availableList = @sortList.filter((sort) ->
          item = ctx.filters.sort.find((item) -> item.field == sort.field)
          !item
        )
        availableList

    methods:
      hiInfiniteScroll: (state) ->
        @actions.fetchResource(state, @resourceKey, @formatFiltersPayload(), { page: @pageNumber })
        @pageNumber += 1

      hiFilterChange: (selectedFilters) ->
        @$refs.infiniteLoading.stateChanger.reset()
        @selectedFilters = selectedFilters if selectedFilters
        @pageNumber = 1
        payload = @formatFiltersPayload()
        @actions.fetchResource(null, @resourceKey, payload, { page: @pageNumber })
        @pageNumber += 1

      formatFiltersPayload: ->
        payload = {...@filters}

        timeWindows = payload.filters
        for field, timeWindow of timeWindows
          delete timeWindows[field] if not timeWindow

        payload

      hiClearFilter: ->
        cleared_filter_scope = @filters.scopes
        Object.keys(cleared_filter_scope).forEach((key) -> cleared_filter_scope[key] = null)
        @selectedFilters = []
        @hiFilterChange()

      hiSearchChange: (q = '') ->
        @filters.q = q
        @hiFilterChange()

      hiAddSort: (order) ->
        return false if !@sortValue.length
        @filters.sort.push({ field: @sortValue, order })
        @hiFilterChange()
        @sortValue = ''

      hiRemoveSort: (sort) ->
        @filters.sort = @filters.sort.filter((item) -> item.field != sort.field)
        @hiFilterChange()

      hiFlipOrder: (sort) ->
        flippedOrder = if sort.order == 'asc' then 'desc' else 'asc'
        @filters.sort = @filters.sort.filter((item) ->
          item.order = flippedOrder if item.field == sort.field
          item
        )
        @hiFilterChange()

      sortOrderIcon: (order) ->
        if order == 'asc'
          return 'fa-arrow-up'

        return 'fa-arrow-down'

      getFieldName: (field) ->
        @sortList.find((item) -> item.field == field).value

      hiAcceptPendingOfferTrigger: (offer) -> @actions.acceptPendingOfferTrigger(offer)

      hiPromptToBulkEditOffers: ->
        modalConfig =
          offerIds: @pluck(@selectedOffers, 'id')
        @actions.bulkEditOffersTrigger {}, modalConfig

      hiPromptToExtendSelectedOffersExpiration: ->
        @actions.promptToExtendOffersExpiration @selectedOffers

      clearSelection: ->
        @selectedOffers = []

export default VueOptions.vue settings
